import { useState } from "react";

export default function Navbar() {
  const [open, setOpen] = useState(false);
    //sync cart with localStorage to ensure count is accurate across tabs
    const cart = JSON.parse(localStorage.getItem("cart")) || [];
    let component
    switch (window.location.pathname) {
      case "/cart":
      component =
    <nav className="nav">
      <a href="/" className="site-title">
        High & Fly
      </a>

      <button className="hamburger" onClick={() => setOpen(!open)}>
        ☰
      </button>

      <ul className={open ? "nav-links active" : "nav-links"}>
        <li><a href="/">Home</a></li>
        <li><a href="/merch">Merch</a></li>
        <li><a href="/about">About</a></li>
        <li><a href="/contact">Contact</a></li>
        <li><a href="/locations">Locations</a></li>
        <li><a href="/checkout">Checkout {cart.length}</a></li>
      </ul>
    </nav>
    break;
    default:
      component =
    <nav className="nav">
      <a href="/" className="site-title">
        High & Fly
      </a>

      <button className="hamburger" onClick={() => setOpen(!open)}>
        ☰
      </button>

      <ul className={open ? "nav-links active" : "nav-links"}>
        <li><a href="/">Home</a></li>
        <li><a href="/merch">Merch</a></li>
        <li><a href="/about">About</a></li>
        <li><a href="/contact">Contact</a></li>
        <li><a href="/locations">Locations</a></li>
        <li><a href="/cart">Cart {cart.length}</a></li>
      </ul>
    </nav>
    }
  return component
}